import { Pipe, PipeTransform } from '@angular/core';
import { IAddress } from '../../models/common/address.model';

@Pipe({
  name: 'countryAndPostalCode'
})
export class CountryWithPostalCodePipe implements PipeTransform {

  transform(value: IAddress, ...args: unknown[]): string {
    const city = value.city || value.additionnalInformation;
    const postalCode = value.postalCode;
    const country = value.shortNameCountry ? value.shortNameCountry : 'FR';
    return postalCode ? `${city} (${country}, ${postalCode})` : `${city} (${country})`;
  }

}
